import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useNotification } from "../../contexts/NotificationContext";
import { authFetch } from '../../utils/authFetch';

const EditarPlano = () => {
    const { id } = useParams();    
    const { showNotification } = useNotification();
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [planTypeId, setPlanTypeId] = useState(0);

    useEffect(() => {
        const fetchPlano = async () => {
            try {
                const response = await authFetch(`plan/${id}`, {                    
                });

                if (!response.ok) throw new Error('Erro ao buscar plano');

                const data = await response.json();
                setName(data.name);
                setPlanTypeId(data.planTypeId);
            } catch (error) {
                console.error(error);
                showNotification("danger", "Erro ao buscar plano");
            }
        };

        fetchPlano();
    }, [id, showNotification]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await authFetch(`plan/${id}`, {
                method: 'PUT',                
                body: JSON.stringify({ name, planTypeId })
            });

            if (!response.ok) throw new Error('Erro ao atualizar plano');

            showNotification("success", "Plano atualizado com sucesso!");
            navigate('/Planos');
        } catch (error) {
            console.error(error);
            showNotification("danger", "Erro ao atualizar plano");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Editar Plano</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <form onSubmit={handleSubmit}>
                            <fieldset className="col-md-6">
                                <div className="mb-3">
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label>Tipo</label>
                                    <select
                                        className="form-control"
                                        value={planTypeId}
                                        onChange={(e) => setPlanTypeId(parseInt(e.target.value))}
                                    >
                                        <option value={0}>Mensal</option>
                                        <option value={1}>Horas</option>
                                    </select>
                                </div>
                                <div className="card-footer" style={{ paddingLeft: "0" }}>
                                    <Link to={'/Planos'} className="btn btn-info btn-sm">Voltar</Link>
                                    <button type="submit" className="btn btn-primary btn-sm mx-1">Salvar</button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditarPlano;
